// extracted by mini-css-extract-plugin
export default {"ModalTitle":"PatientDetailsModal_ModalTitle__p2oQE","ModalDate":"PatientDetailsModal_ModalDate__4L-vI"};